import React, { type FunctionComponent, Suspense } from 'react';

import { Loader } from '@sine/sine-ui-components';

export default function wrapLazyLoad(LazyComponent: FunctionComponent) {
  return ((props) => (
    <Suspense fallback={<Loader show fillAndCenter />}>
      <LazyComponent {...props} />
    </Suspense>
  )) as FunctionComponent;
}
